'use strict';

const _ = require('underscore');
const ProjectStatusRepository = require('common/domain/repository/project-status');

class Service {
    constructor(group) {
        this.waitInterval = 2 * 1000; // 単位: ミリ秒

        this._group = group;
        this._projectStatusRepository = ProjectStatusRepository.find(this._group);
    }

    fetch(project) {
        return this._projectStatusRepository.fetchByProject(project);
    }

    fetchNoRaise(project) {
        return this._projectStatusRepository.fetchByProject(project, { noRaise: true });
    }

    fetchPolling(project, resolve = null) {
        if (resolve) {
            this.fetchNoRaise(project)
                .then(projectStatus => {
                    if (projectStatus) {
                        resolve(projectStatus);
                        return;
                    }
                    _.delay(
                        () => {
                            this.fetchPolling(project, resolve);
                        },
                        this.waitInterval
                    );
                });
            return;
        }

        return new Promise(resolve => {
            this.fetchPolling(project, resolve);
        });
    }
}

module.exports = Service;



// WEBPACK FOOTER //
// ./common/app/service/project-status/fetch.js